module.exports = __webpack_public_path__ + "static/media/test.1a02b733.png";